import React, { FC, memo } from 'react'
import { useSwipeable } from 'kat/lib/utilities/swipeable/swipeable'
import { css } from 'emotion'
import { clientMeta } from 'kat/lib/utilities/clientMeta'
import { useDispatch } from 'react-redux'
import { ToggleAction } from 'actionCreators/ToggleAction'
import { useSelector } from 'react-redux'
import { StateReducers } from 'state/reducers/types/StateReducers'
import { getIsMediumScreen } from 'kat/lib/state/getters/getIsMediumScreen'
import { GoBackAction } from 'kat/lib/actionCreators/GoBackAction'
import { GoForwardAction } from 'kat/lib/actionCreators/GoForwardAction'
import { StartMainConnected } from 'com/main/StartMain/StartMainConnected'

interface AppMainProps {
  showError?: boolean
  styles?: string
}

const description = 'AppMain'
export const AppMain: FC<AppMainProps> = memo(({ styles = '' }) => {
  const slideContainer = useSelector((state: StateReducers) => {
    return state.elements?.slideContainer
  })

  const isMediumScreen = useSelector((state: StateReducers) => {
    return getIsMediumScreen({ state })
  })

  const windowHeight = useSelector((state: StateReducers) => {
    return state.windowMeta?.height || 0
  })

  const showSlideRight = useSelector((state: StateReducers) => {
    return state.toggles?.showSlideRight
  })

  const showSlideUp = useSelector((state: StateReducers) => {
    return !!state.toggles?.showSlideUp
  })

  const windowWidth = useSelector((state: StateReducers) => {
    return state.windowMeta?.width || 0
  })

  const dispatch = useDispatch()
  const swipeable = useSwipeable({
    delta: {
      left: 25,
      right: 25,
      up: 200,
      down: 200,
    },
    preventDefaultTouchmoveEvent: true,
    preventMixDirections: true,
    onSwiping: (e) => {
      const selection = window.getSelection()
      if (!selection?.toString()) {
        if (slideContainer && (e.dir === 'Left' || e.dir === 'Right')) {
          slideContainer.style.transition = 'margin-left 0.2s ease-out'
          slideContainer.style.marginLeft = e.deltaX + 'px'
        }
      }
    },
    onSwiped: (e) => {
      const threshold = windowWidth / 2
      const isHighVelocity = e.velocity > 0.4
      if (slideContainer) {
        const rect = slideContainer.getBoundingClientRect()
        slideContainer.style.marginLeft = '0px'

        if (rect.left > threshold || (isHighVelocity && rect.left > 1)) {
          slideContainer.style.transition = 'initial'

          if (showSlideUp) {
            dispatch<ToggleAction>({
              type: 'TOGGLE',
              description,
              toggles: {
                showSlideUp: false,
              },
            })
          } else {
            dispatch<GoBackAction>({
              type: 'GO_BACK_ACTION',
              description,
            })
          }
        }

        if (
          rect.left < 0 &&
          (rect.left * -1 > threshold || (isHighVelocity && rect.left < -1))
        ) {
          slideContainer.style.transition = 'initial'
          if (showSlideRight) {
            dispatch<ToggleAction>({
              type: 'TOGGLE',
              description,
              toggles: {
                showSlideRight: false,
              },
            })
          }
          dispatch<GoForwardAction>({
            type: 'GO_FORWARD_ACTION',
            description,
          })
        }
      }
    },
  })

  return (
    <div
      ref={swipeable.ref}
      className={`AppMain ${css`
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        min-height: ${
          /* old android is not supporting dvh */
          clientMeta.isAndroid ? `${windowHeight}px` : '100dvh'
        };
        overflow: hidden;
        ${clientMeta.isTouch
          ? css`
              -webkit-touch-callout: none;
              -webkit-user-select: none;
              -khtml-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
            `
          : ''}
        ${false ? styles : ''}
      `} ${isMediumScreen ? 'isMediumScreen' : ''}`}
    >
      <StartMainConnected />
    </div>
  )
})

export default AppMain
